import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const COI_SERVICE_WORKER_PATH = "/coi-serviceworker.js";
const COI_SW_RELOAD_SESSION_KEY = "rezrate_video_coi_sw_reload_once";

const cleanupLegacyCoiServiceWorker = async () => {
  if (
    typeof window === "undefined" ||
    typeof navigator === "undefined" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    let unregisteredAny = false;

    await Promise.all(
      registrations.map(async (registration) => {
        const scriptUrls = [
          registration?.active?.scriptURL,
          registration?.waiting?.scriptURL,
          registration?.installing?.scriptURL,
        ].filter(Boolean);

        const isCoiWorker = scriptUrls.some((url) =>
          `${url}`.includes(COI_SERVICE_WORKER_PATH)
        );

        if (!isCoiWorker) {
          return;
        }

        const didUnregister = await registration.unregister();
        unregisteredAny = unregisteredAny || !!didUnregister;
      })
    );

    if (!unregisteredAny) {
      return;
    }

    console.info("[RezRATE][video-window]", "coi.sw.unregistered");

    const hasReloadedOnce =
      window.sessionStorage.getItem(COI_SW_RELOAD_SESSION_KEY) === "1";
    if (!hasReloadedOnce) {
      window.sessionStorage.setItem(COI_SW_RELOAD_SESSION_KEY, "1");
      window.location.reload();
    }
  } catch (error) {
    // ignore cleanup errors
  }
};

cleanupLegacyCoiServiceWorker();

const root = ReactDOM.createRoot(
  document.getElementById("root")
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
